import React from 'react';

export interface ElementFieldLayoutProps {
    label?: React.ReactNode;
    decoration?: React.ReactNode;
    issue?: React.ReactNode | undefined;
    helperText?: React.ReactNode;
    isInvalid?: boolean | undefined;
    isDisabled?: boolean | undefined;
}

export function ElementFieldLayout({
    label,
    isInvalid = false,
    isDisabled = false,
    decoration,
    issue,
    helperText,
    children,
}: React.PropsWithChildren<ElementFieldLayoutProps>) {
    if (issue) {
        helperText = issue;
        isInvalid = true;
    }
    return (
        <div className={`~Field__root ${!isDisabled && isInvalid ? '~Field__root--invalid' : ''}`}>
            {label}
            <div className={'~Field__innerBox'}>
                {children}
                <span className={'~Field__decor ~Field__decor--big'}>{decoration}</span>
            </div>
            <span className={'~Field__helper'}>{helperText}</span>
        </div>
    );
}
